import React from 'react'
import _ from 'lodashParts'

import DropDown from 'wix-base-ui/lib/controls/dropDown'
import ThemeOption from './themeOption.jsx'

class ThemeDropDown extends React.Component {
    handleThemeChanged(val) {
        const themeCssClassName = val
        const tag = this.props.themes[themeCssClassName].tag
        this.props.execCommand('formatBlock', {
            class: themeCssClassName,
            tag
        })
    }

    render() {
        if (this.props.themes && Object.keys(this.props.themes).length > 0) {
            return (
                <DropDown automationId="themes-drop-down" optionsContainerClassName="richtext-dropdown-options richtext-themes-dropdown-options" onChange={ val => this.handleThemeChanged(val)} value={this.props.value} className="richtext-dropdown richtext-themes-dropdown toolbar-mode">
                    {
                        _.map(this.props.themes, (theme, key) => <ThemeOption value={key} key={key} theme={theme} name={theme.displayName || key} translate={this.props.translate}/>)
                    }
                </DropDown>
            )
        }

        return null
    }
}

ThemeDropDown.propTypes = {
    themes: React.PropTypes.object.isRequired,
    value: React.PropTypes.string,
    translate: React.PropTypes.func.isRequired,
    execCommand: React.PropTypes.func
}

module.exports = ThemeDropDown



// WEBPACK FOOTER //
// ./src/components/toolbar/themeDropDown.jsx